/** English catalog — default / fallback. Move names & Pokémon species stay English. */
export default {
  'deposit.title': 'Deposit',
  'deposit.eyebrow': 'Pokémon Center',
  'deposit.sub': 'Store items and move Pokémon between your team and the Box.',
  'deposit.close': 'Close deposit',
  'deposit.items': 'Items',
  'deposit.pokemon': 'Pokémon',
  'deposit.searchItem': 'Search item...',
  'deposit.itemCategory': 'Filter item category',
  'deposit.allCategories': 'All categories',
  'deposit.balls': 'Poké Balls',
  'deposit.potions': 'Potions',
  'deposit.stones': 'Stones',
  'deposit.loot': 'Loot',
  'deposit.backpack': 'Backpack',
  'deposit.storage': 'Deposit',
  'deposit.storeAll': 'Store all',
  'deposit.searchPokemon': 'Search Pokémon...',
  'deposit.filterShiny': 'Shiny only',
  'deposit.from': 'from',
  'deposit.to': 'to',
  'deposit.level': 'Level',
  'deposit.team': 'Team',
  'deposit.box': 'Box',
  'deposit.pokemonHint': 'Move Pokémon between your team and the Box. Your main partner remains equipped.',
  'deposit.open': 'Deposit',
  'deposit.openAria': 'Open the Pokémon Center deposit',
  'deposit.resultsOf': '{filtered} of {total} Pokémon in the Box',
  'deposit.noTeam': 'No Pokémon equipped.',
  'deposit.pokemonCount': '{count} Pokémon',
  'deposit.itemCount': '{count} stored items',
  'deposit.mainPartner': 'The main partner cannot be deposited',
  'deposit.moveToBox': 'Move to Box',
  'deposit.moveToTeam': 'Move to team',
  'deposit.emptyBackpack': 'No backpack items match these filters.',
  'deposit.emptyStorage': 'Nothing in the deposit matches these filters.',
  'deposit.withdrawItem': 'Withdraw item',
  'deposit.storeItem': 'Store item',
  'deposit.serverItemsDisabled': 'With server inventory, item storage is disabled (use the backpack).',
  'deposit.category.BALL': 'Poké Ball',
  'deposit.category.POTION': 'Potion',
  'deposit.category.STONE': 'Stone',
  'deposit.category.LOOT': 'Loot',
  'nav.main': 'Main navigation',
  'nav.city': 'City',
  'nav.hunt': 'Hunt',
  'nav.captures': 'Captures',
  'nav.automation': 'Automation',
  'nav.inventory': 'Inventory',
  'nav.pokedex': 'Pokédex',
  'nav.market': 'Market',
  'nav.emeraldStore': 'Emerald Store',
  'nav.gamePass': 'Game Pass',
  'nav.dailyGift': 'Daily Gift',
  'nav.specialization': 'Specialization',
  'nav.myPokemon': 'My Pokémon',
  'nav.collection': 'Collection',
  'nav.map': 'Map',
  'nav.altar': 'Altar',
  'nav.breeding': 'Breeding',
  'nav.atlas': 'Hunt Atlas',
  'nav.systems': 'Systems',
  'nav.compare': 'Compare Pokémon',
  'compare.eyebrow': 'Battle lab',
  'compare.title': 'Compare Pokémon',
  'compare.sub': 'Compare simulated species or your Pokémon, projecting level and evolution without changing your collection.',
  'compare.close': 'Close comparison',
  'compare.left': 'Pokémon 1',
  'compare.right': 'Pokémon 2',
  'compare.swap': 'Swap Pokémon',
  'compare.modeLabel': 'Comparison source',
  'compare.modeSpecies': 'Simulate species',
  'compare.modeOwned': 'My Pokémon',
  'compare.search': 'Search Pokémon...',
  'compare.searchOwned': 'Search your Pokémon...',
  'compare.noOwned': 'You do not have any Pokémon to compare yet.',
  'compare.pick': 'Search a Pokémon to start.',
  'compare.rarity': 'Rarity',
  'compare.quality': 'Quality (IV)',
  'compare.results': 'Head-to-head',
  'compare.needBoth': 'Pick both Pokémon to see the head-to-head.',
  'compare.power': 'Power',
  'compare.tie': 'Tie',
  'compare.powerLead': '{percent}% more Power',
  'compare.wins': '{name} wins',
  'compare.ownedBadge': 'Your Pokémon',
  'compare.originalLevel': 'Current level',
  'compare.simulatedLevel': 'Simulated level',
  'compare.evolution': 'Simulated evolution',
  'compare.evolutionRequirement': 'Lv. {level}',
  'compare.shiny': 'Shiny',
  'compare.band.regular': 'Regular',
  'compare.band.promissor': 'Promising',
  'compare.band.elite': 'Elite',
  'compare.band.perfeito': 'Perfect',
  'compare.note': 'In species mode, the simulation uses the rarity tier’s nominal multiplier and IVs spread evenly across stats. In My Pokémon mode, real data is used only for the preview; nothing here changes your collection.',
  'altar.eyebrow': 'Guaranteed path',
  'altar.title': 'Shiny Altar',
  'altar.intro': 'Spend generic Shiny Cards to summon a guaranteed shiny battle of a species you have already seen.',
  'altar.steps': '1) Earn 50 cards · 2) choose a species you have seen · 3) summon a guaranteed shiny encounter window.',
  'altar.cards': 'Shiny Cards',
  'altar.cardsOwned': '{count} cards',
  'altar.cost': 'Cost: {cost}',
  'altar.pickSpecies': 'Pick a species',
  'altar.search': 'Search species...',
  'altar.invoke': 'Summon shiny',
  'altar.needCards': 'Not enough Shiny Cards.',
  'altar.needSpecies': 'Select a species you have seen.',
  'altar.invoked': 'Shiny {name} summoned!',
  'altar.close': 'Close altar',
  'shiny.wildAppeared': '✦ Shiny {name} appeared!',
  'shiny.captured': '✦ Shiny {name} caught!',
  'shiny.cardDrop': '+{count} Shiny Card(s)',
  'shiny.guaranteed': 'Guaranteed shiny encounter',
  'breeding.eyebrow': 'Breeding Center',
  'breeding.title': 'Breeding',
  'breeding.intro': 'Two parents become one egg — IV inheritance, quality climbing generation after generation, and the hunt for the perfect bloodline.',
  'breeding.pair': 'Breeding pair',
  'breeding.slot': 'Slot {n}',
  'breeding.pickFromBox': 'Select from the box',
  'breeding.clearSlot': 'Remove from slot',
  'breeding.parentsConsumed': 'Both parents are CONSUMED when the egg is created. Child quality = best parent + Δ.',
  'breeding.analysis': 'Breeding analysis',
  'breeding.mysteryChild': 'Mysterious child',
  'breeding.emptyAnalysis': 'Pick 2 parents from the box to reveal the compatibility analysis and quality range.',
  'breeding.step1Title': 'Pick 2 parents',
  'breeding.step1Text': 'Same species, straight from your box',
  'breeding.step2Title': 'Pay the cost',
  'breeding.step2Text': 'Coins, elemental stones and pheromones',
  'breeding.step3Title': 'Hatch by hunting',
  'breeding.step3Text': 'Hunt defeats incubate the egg',
  'breeding.needPair': 'Pick 2 parents',
  'breeding.needPairToast': 'Select two Pokémon of the same species.',
  'breeding.incompatible': 'Incompatible pair',
  'breeding.incompatibleHint': 'Both parents must be of the same species.',
  'breeding.compat': 'Compatibility',
  'breeding.ivInherit': 'IV inheritance',
  'breeding.qualityProjected': 'Projected quality',
  'breeding.bestParent': 'Best parent: Q {q}',
  'breeding.cap': 'cap {cap}',
  'breeding.deltaChances': 'Δ chances (added to best parent)',
  'breeding.ivCopyNote': 'IV copies the higher-Quality parent',
  'breeding.ivCopyBonus': '·+15%',
  'breeding.modePheromones': 'Pheromones',
  'breeding.modePheromonesHint': 'Full Δ (+0.15 to +0.30)',
  'breeding.modeFree': 'Free',
  'breeding.modeFreeHint': 'Δ ~20× smaller · ~20% lower cost',
  'breeding.hatchInfo': 'Hatches within {count} hunt defeats',
  'breeding.doubleStones': 'Double stones',
  'breeding.doubleStonesHint': '+15% inheritance · 5% chance of +1 IV',
  'breeding.youHave': 'you have {count}',
  'breeding.costLacking': 'Insufficient funds',
  'breeding.createEgg': 'Create egg',
  'breeding.eggCreated': 'Egg created and placed in the incubator!',
  'breeding.incubator': 'Incubator',
  'breeding.incubatorFull': 'Incubator full',
  'breeding.incubatorFullToast': 'Incubator full (2 slots).',
  'breeding.slotFree': 'Free slot',
  'breeding.noEggs': 'No eggs incubating.',
  'breeding.eggProgress': '{current} / {needed} defeats',
  'breeding.eggReady': 'Ready to hatch!',
  'breeding.hatched': '{name} hatched!',
  'breeding.activeBonuses': 'Active bonuses',
  'breeding.bonusPheromonesText': '+0.15 to +0.30 quality on the child',
  'breeding.bonusFreeText': 'Δ ~20× smaller · ~20% lower cost',
  'breeding.bonusDouble': 'Double stones',
  'breeding.bonusDoubleText': '+15% inheritance · 5% chance of +1 IV',
  'breeding.box': 'Your Pokémon (box)',
  'breeding.searchPlaceholder': 'Search by name...',
  'breeding.sortIv': 'Highest IV',
  'breeding.sortQuality': 'Highest Q',
  'breeding.sortLevel': 'Highest Lv.',
  'breeding.sortName': 'Name A–Z',
  'breeding.emptyBox': 'No Pokémon available in the box.',
  'breeding.close': 'Close breeding',
  'breeding.notEnoughCoins': 'Not enough gold.',
  'breeding.notEnoughStones': 'Not enough stones.',
  'breeding.notEnoughPheromones': 'Not enough pheromones.',
  'atlas.eyebrow': 'Hunts',
  'atlas.title': 'Hunt Atlas',
  'atlas.intro': 'Pick a type, level band, and the specific species you want to hunt.',
  'atlas.pickType': 'Type',
  'atlas.pickLevel': 'Level',
  'atlas.pickSpecies': 'Species',
  'atlas.search': 'Search species...',
  'atlas.difficulty': 'Difficulty',
  'atlas.seen': 'Seen',
  'atlas.caught': 'Caught',
  'atlas.notCaught': 'Not caught',
  'atlas.speciesCount': '{count} species',
  'atlas.levelLabel': 'Hunt level',
  'atlas.unlockRequirement': 'Unlock requirement',
  'atlas.unlockHint': 'Keep leveling your Trainer to unlock this hunt.',
  'atlas.unseen': '???',
  'atlas.startHunt': 'Hunt {name} · Lv.{level}',
  'atlas.startFailed': 'Could not start the hunt. Open the console (F12) and try again.',
  'atlas.needPartner': 'Equip a partner Pokémon before hunting.',
  'atlas.bossTag': 'Boss',
  'atlas.zoneTag': 'Zone',
  'atlas.zoneLevelLabel': 'Zone tier',
  'atlas.species': 'Pool',
  'atlas.pickZone': 'Zone',
  'atlas.zoneTitle': '{type} Zone · Lv.{level}',
  'atlas.zoneIntro': 'Mono-species packs spawn in map corners. A mini-boss may summon adds — use an area skill.',
  'atlas.zoneIntroShort': 'In the endgame you face full biomes with their own rules, pools, and legendary bosses.',
  'atlas.zoneAoeHint': 'Recommended: equip a TM / area skill on your Pokémon.',
  'atlas.zoneAoeWarn': 'Dense zone: equip an area skill (TM) to clear the packs.',
  'atlas.startZone': 'Enter {type} · {level}',
  'atlas.back': 'Back',
  'atlas.close': 'Close atlas',
  'atlas.empty': 'No species in this band.',
  'atlas.legacyMode': 'Legacy type×band mode',
  'hunt.speciesFocus': 'Focus: {name}',
  'hunt.mapTransition': '{name} left the ruins — the hunt moves into the desert.',
  'hunt.mapTransitionLog': '{name} crossed the pyramid and reached the desert.',
  'hunt.zoneFocus': '{type} · {level}',
  'team.aoeSlot': 'Area skill',
  'team.aoeLocked': 'Unlocked at Lv.{level}',
  'team.aoeEmpty': 'No TM equipped',
  'team.equipTm': 'Equip TM',
  'team.unequipAoe': 'Remove AoE',
  'team.tmOwned': '{count} TM(s)',
  'team.tmApplied': 'TM applied: {move}',
  'team.noTm': 'You have no TMs.',
  'boss.label': 'BOSS',
  'boss.adds': '+{count} adds',
  'battle.multiTargets': '{count} targets',
  'zone.apex': 'Apex',
  'zone.threatTier': 'Threat {tier}',
  'zone.recommendedPower': 'Recommended power',
  'zone.powerValue': 'Recommended power: {power}',
  'zone.nextBoss': 'Next legendary',
  'zone.rewardBonus': 'XP bonus',
  'zone.bossProgress': 'Legendary trail',
  'zone.effectsSummary': '+{xp}% XP · +{loot}% drops · +{damage}% enemy damage',
  'zone.legendaryRotation': 'Legendary rotation',
  'zone.legendaryGuideTitle': 'How the legendary appears',
  'zone.legendaryGuide': 'Defeat {count} Pokémon in this zone to complete the Legendary Trail. The next special encounter will be {name}; defeating or capturing it resets the trail and advances the rotation.',
  'zone.legendaryBoss': 'LEGENDARY',
  'zone.mythicalBoss': 'MYTHICAL',
  'zone.hourlyFeatured': 'Hourly focus',
  'zone.hourlyFocusTitle': 'Special encounter (GMT-3)',
  'zone.hourlyFocusGuide': 'Rare chance (~1 in {n} KOs) for the featured {kind}: {name}. No pity. One ball per KO — Master/Apex recommended.',
  'zone.rotationCountdown': 'Rotates in {time}',
  'zone.specialOdds': '~1/{n} KOs',
  'zone.specialPool': 'Hourly pool',
  'zone.noSpecial': '—',
  'zone.noSpecialTitle': 'No special rotation',
  'zone.noSpecialHint': 'This zone has biome packs and mini-bosses only — no hourly legendary/mythical.',
  'zone.captureHint': 'Ultra is ~1% at endgame. Master Ball is guaranteed; Apex Ball is ~25% on zone specials.',
  'zone.specialAppearedLog': '{name} appeared in {zone} (hourly focus)!',
  'zone.specialAppearedToast': '{name} appeared! Hourly focus.',
  'zone.enter': 'Enter zone',
  'zone.requirement.trainerLevel': 'Trainer Lv.{value}',
  'zone.requirement.mastery': 'Mastery {value}',
  'zone.requirement.prestige': 'Prestige {value}',
  'zone.bossReadyLog': 'The trail in {zone} is complete. The legendary has appeared.',
  'zone.bossReadyToast': 'Legendary boss unlocked!',
  'zone.bossDefeated': '{name} was defeated in {zone}.',
  'zone.bossDefeatedToast': '{name} defeated!',
  'zones.supreme-threshold.title': 'Supreme Frontier',
  'zones.supreme-threshold.description': 'Champions from many biomes test your team before the greater threats.',
  'zones.ashen-spire.title': 'Ashen Spire',
  'zones.ashen-spire.description': 'Extreme heat empowers attackers and makes every assault more dangerous.',
  'zones.obsidian-court.title': 'Obsidian Court',
  'zones.obsidian-court.description': 'A fortress of steel and stone built for long battles against heavy defenses.',
  'zones.eclipse-rift.title': 'Eclipse Rift',
  'zones.eclipse-rift.description': 'Shadow and psychic energy: legendary pool with an hourly featured spawn (GMT-3).',
  'zones.final-horizon.title': 'Final Horizon',
  'zones.final-horizon.description': 'The ultimate challenge: mythical pool with hourly focus and the toughest endgame captures.',

  'items.apexball.name': 'Apex Ball',
  'items.apexball.desc': '~25% catch rate on Threat 3/4 zone specials.',
  'shop.emeraldBalls': 'Premium balls',
  'shop.vipMasterGift': 'Activating VIP grants 1 Master Ball.',

  'profile.trainer': 'Trainer',
  'profile.level': 'Level',
  'profile.title': 'Profile',
  'profile.sub': 'Trainer identity, progress and shortcuts.',
  'profile.general': 'General info',
  'profile.progression': 'Progression',
  'profile.captureLog': 'Capture log',
  'profile.customizeOutfit': 'Customize outfit',
  'profile.saveOutfit': 'Save outfit',
  'profile.outfitEyebrow': 'Appearance',
  'profile.outfitTitle': 'Customize outfit',
  'profile.openPrestige': 'Trainer & Prestige',
  'profile.since': 'since the start',
  'profile.coins': 'Gold',
  'profile.defeated': 'Defeats',
  'profile.captured': 'Captures',
  'profile.pokedex': 'Pokédex',
  'profile.prestige': 'Prestige',
  'profile.peakLevel': 'Peak level',
  'profile.talents': 'Specialization points',
  'profile.outfitSaved': 'Outfit updated!',
  'profile.xpLine': '{current} / {max} XP',
  'profile.xpReady': 'Ready for Prestige',
  'profile.pokedexProgress': '{owned}/{total}',
  'profile.footer': 'IdleMon — {name}\'s profile',

  'settings.open': 'Settings',
  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.language.en': 'English',
  'settings.language.pt-BR': 'Português (BR)',
  'settings.language.es': 'Español',
  'settings.close': 'Close settings',

  'common.close': 'Close',
  'common.new': 'New',
  'confirm.eyebrow': 'Confirmation',
  'confirm.title': 'Confirm action',
  'common.you': 'You',
  'common.lv': 'Lv.',
  'common.coins': 'IdleCoin',
  'common.active': 'ACTIVE',
  'common.buy': 'Buy',
  'common.sell': 'Sell',
  'common.selectAll': 'Select all',
  'common.evolve': 'Evolve',
  'common.status': 'Status',
  'common.power': 'Power',
  'common.emptySlot': 'Empty slot',
  'common.learned': 'LEARNED',
  'common.area': 'Area',

  'battle.searching': 'SEARCHING FOR POKÉMON',
  'battle.searchingNext': 'SEARCHING FOR NEXT',
  'battle.paused': 'JOURNEY PAUSED',
  'battle.walking': 'Walking automatically',
  'battle.seekingTarget': '{name} is looking for a target',
  'battle.yourPokemon': '{name} · Your Pokémon',
  'battle.sound': 'Toggle sound',
  'battle.routeLabel': '{type} ROUTE · LEVEL {min}–{max}',
  'battle.defeatedTitle': '{name} defeated!',
  'battle.cannotAttack': '{name} cannot attack!',
  'battle.combat': 'Combat',
  'battle.expTrainer': 'Trainer EXP',
  'battle.expPokemon': 'Pokémon EXP',
  'battle.total': 'total',
  'battle.levelUp': '{name} reached Lv. {level}!',
  'levelup.eyebrow': 'LEVEL UP!',
  'levelup.text': 'You reached a new level!',
  'battle.drops': 'Items',

  'team.heading': 'MY TEAM',
  'team.equipped': 'Equipped Pokémon',
  'team.aria': 'My team',
  'team.manageTitle': 'My Pokémon',
  'team.manageEyebrow': 'Active team',
  'team.manageHint': 'Manage stats, evolution, and moves for your six equipped Pokémon.',
  'team.close': 'Close My Pokémon',
  'team.noPartner': 'Choose your first partner before managing the team.',
  'team.movesDiscarded': 'Unapplied move changes were discarded.',
  'team.movesApplied': '{name}\'s moves applied!',
  'team.evolveTo': 'Evolve to {name}',
  'team.noMoves': 'No moves available at this level.',
  'team.applyMoves': 'Apply moves',

  'hunt.last': 'Last hunt',
  'hunt.analyzer': 'Hunt Analyzer',
  'hunt.sub': 'Session rates, loot and balance from your last hunt.',
  'hunt.close': 'Close Hunt Analyzer',
  'hunt.lastRoute': 'LAST COMPLETED ROUTE',
  'hunt.none': 'No hunt recorded',
  'hunt.completeHint': 'Complete a journey to see the summary.',
  'hunt.time': 'Hunt time',
  'hunt.defeated': 'Defeated',
  'hunt.captured': 'Captured',
  'hunt.xp': 'EXP gained',
  'hunt.currentSession': 'CURRENT SESSION',
  'hunt.loot': 'Loot',
  'hunt.supply': 'Supply',
  'hunt.itemsCount': '{count} items',
  'hunt.supplyDetail': '{balls} balls · {potions} potions',
  'hunt.balance': 'Balance (Loot + Captures − Supply)',
  'hunt.sessionDrops': 'Session drops',
  'hunt.noDrops': 'No item drops yet.',
  'hunt.rateHint': 'Rates based on the last 10 minutes of hunting',
  'hunt.grossRate': 'Gross income / hour',
  'hunt.supplyRate': 'Supply burn / hour',
  'hunt.netRate': 'Net balance / hour',
  'hunt.economyHealthy': 'Hunt is sustainable in this sample',
  'hunt.economyWarning': 'Supply costs exceed income — adjust route/loadout',

  'capture.title': 'Capture Log',
  'capture.eyebrow': 'Capture record · last 100',
  'capture.sub': 'Recent captures with rarity, IV and shiny highlights.',
  'capture.close': 'Close capture log',
  'capture.total': 'Total:',
  'capture.normals': 'Normal:',
  'capture.filterAll': 'All',
  'capture.filterNormal': 'Normal',
  'capture.foot': '✨ Shiny captures are highlighted. History updates automatically.',
  'capture.empty': 'No captures found for this filter.',
  'capture.ivUnavailable': 'Detailed IVs are unavailable for this capture.',
  'capture.panelTitle': 'Capture',
  'capture.ready': '{count} ready',
  'capture.throw': 'Throw',
  'capture.caught': 'Caught',
  'capture.escaped': 'Broke free',
  'capture.chance': '{pct}%',
  'capture.noBall': 'No balls',
  'capture.autoCaught': 'Caught!',
  'capture.autoEscaped': 'Broke free',
  'capture.capReached': 'Daily capture limit reached',
  'capture.shinyCapReached': 'Daily shiny capture limit reached',
  'capture.highIvCapReached': 'Daily high-IV capture limit reached',
  'capture.autoChance': '{pct}% chance',
  'capture.vipSkip': 'Skipped (VIP filter)',

  'auto.eyebrow': 'Automation',
  'auto.title': 'Auto-Helper',
  'auto.sub': 'Choose how your partner uses the items in your bag.',
  'auto.close': 'Close automation',
  'auto.capture': 'Auto-capture',
  'auto.captureHint': 'Try to capture after winning',
  'auto.captureNormalHint': 'Catch normal Pokémon after a win',
  'auto.captureVip': 'VIP feature — subscribe to capture automatically after a win.',
  'auto.ball': 'Poké Ball used',
  'auto.ballNone': 'No Poké Balls in inventory.',
  'auto.potion': 'Auto-potion',
  'auto.potionHint': 'Heal automatically at low HP',
  'auto.potionWhen': 'Use potion when HP ≤',
  'auto.potionUsed': 'Potion used',
  'auto.revive': 'Auto-revive',
  'auto.reviveHint': 'Use a Revive when your partner faints',
  'auto.reviveUsed': 'Revive used',
  'auto.reviveStock': '{count} Revive(s) available',
  'auto.reviveNone': 'No Revives in inventory.',
  'auto.shiny': 'Auto-catch Shiny',
  'auto.shinyHint': 'Use a dedicated ball for Shiny Pokémon',
  'auto.shinyBall': 'Poké Ball for Shiny',
  'auto.vip': 'Selective capture',
  'auto.vipHint': 'Only capture the Pokémon you pick on this route.',
  'auto.vipNote': '✦ Available with VIP subscription',
  'auto.speciesOnRoute': '{count} species on this route',
  'auto.pickAny': 'Select any combination',
  'auto.emptyPool': 'No encounters configured on this route.',

  'inv.eyebrow': 'Trainer bag',
  'inv.title': 'Inventory',
  'inv.sub': 'Balls, potions, drops and supplies.',
  'inv.close': 'Close inventory',
  'inv.items': 'Items:',
  'inv.drops': 'Drops:',
  'inv.dropsValue': '{value} IdleCoin',
  'inv.foot': 'Drops can be sold at the city shop. Potions and balls also appear in Automation.',
  'inv.empty': 'Empty bag.',
  'inv.section.balls': 'Poké Balls',
  'inv.section.potions': 'Potions',
  'inv.section.stones': 'Evolution stones',
  'inv.section.drops': 'Drops',

  'dex.eyebrow': 'Species with Myst sprites',
  'dex.title': 'Pokédex',
  'dex.sub': 'Browse species, stats, evolutions and sell estimates.',
  'dex.close': 'Close Pokédex',
  'dex.search': 'Search name or #...',
  'dex.allTypes': 'All types',
  'dex.ownedOnly': 'Caught only',
  'dex.seen': 'Seen:',
  'dex.caught': 'Caught:',
  'dex.emptyDetail': 'Select a Pokémon to see stats, evolutions, and sell price.',
  'dex.filterType': 'Filter by type',
  'dex.locations': 'Where it appears',
  'dex.atlasFocus': 'Hunt focus',
  'dex.fishing': 'Fishing',
  'dex.noLocations': 'Does not appear on current wild routes (outside the hunt pool).',
  'dex.capture': 'Capture',
  'dex.catchInfo': 'Base species difficulty: {label} · base rate {rate} · level and ball determine the real combat chance.',
  'dex.baseStats': 'Base stats',
  'dex.stat.hp': 'HP',
  'dex.stat.atk': 'Atk',
  'dex.stat.def': 'Def',
  'dex.stat.spa': 'Sp.Atk',
  'dex.stat.spd': 'Sp.Def',
  'dex.stat.spe': 'Spe',
  'dex.evoLine': 'Evolution line',
  'dex.baseForm': 'base',
  'dex.sellSection': 'Sell',
  'dex.sellNote': 'Estimated transfer for a common Lv.1/IV50 specimen: {price} IdleCoin. Value scales with level, IV, and quality.',
  'dex.notOwned': 'You do not own this Pokémon yet. Catch one to sell it.',
  'dex.noneFound': 'No Pokémon found.',
  'dex.legendary': 'LEGENDARY',

  'col.eyebrow': 'Personal Pokédex',
  'col.title': 'Your collection',
  'col.close': 'Close collection',
  'col.hint': 'Rarity and IV in the list · click for details',
  'col.search': 'Search by name...',
  'col.filterType': 'Filter by type',
  'col.filterRarity': 'Filter by rarity',
  'col.ivMode': 'IV filter mode',
  'col.ivMin': 'Min IV',
  'col.ivMax': 'Max IV',
  'col.ivValue': 'Total IV from 0 to 186',
  'col.clear': 'Clear filters',
  'col.allTypes': 'All types',
  'col.allRarities': 'All rarities',
  'col.results': '{count} Pokémon',

  'city.safeZone': 'Safe zone · Multiplayer',
  'city.walkHint': 'Use W A S D to walk · original map',
  'city.floor': 'Floor 7',
  'city.teleport': 'City shortcut',
  'city.teleportHint': 'Go to shop',
  'city.teleportTitle': 'City destinations',
  'city.teleportAria': 'Teleport to shop',
  'city.teleportMenuAria': 'City teleport destinations',
  'city.teleportDestinations': '{count} destinations available',
  'city.arrivedNpc': 'You arrived at {name}.',
  'city.store': 'Store',
  'city.storeAria': 'Go to the shop',
  'city.healTeam': 'Heal team',
  'city.openShop': 'Open shop',
  'city.openTmShop': 'View TM drops',
  'city.fisherName': 'Finn',
  'city.startFishing': 'Start fishing',
  'city.mapAlt': 'Saffron City from the original Poketibia map',
  'city.roofsAlt': 'Saffron City roofs',
  'city.pcRoofAlt': 'Pokémon Center roof',
  'city.shopRoofAlt': 'Shop roof',
  'city.trainerAlt': 'Your trainer',
  'city.partnerAlt': 'Your main Pokémon',
  'city.routeMapAlt': 'Original route map',
  'city.arrivedShop': 'You arrived at the shop.',
  'city.welcome': 'Welcome to Saffron City, trainer!',
  'city.marketSoon': 'Trading market coming soon.',
  'city.soundSoon': 'Sound will be added with battle effects.',

  'fish.eyebrow': 'Saffron pier',
  'fish.title': 'Fishing',
  'fish.sub': 'Pick a spot, bait and rod, then cast. Aquatic species are only caught here.',
  'fish.hint': 'Aquatic Pokémon are caught here. A rod sets the ceiling; it does not raise your level or pick a band for you.',
  'fish.statusEyebrow': 'Status',
  'fish.spotEyebrow': 'Spot',
  'fish.baitEyebrow': 'Bait',
  'fish.rodEyebrow': 'Rod',
  'fish.idle': 'Ready to cast.',
  'fish.casting': 'Line in the water…',
  'fish.start': 'Start fishing',
  'fish.stop': 'Stop fishing',
  'fish.started': 'Fishing started.',
  'fish.stopped': 'Fishing stopped.',
  'fish.needRod': 'Buy a fishing rod at the shop.',
  'fish.busyHunt': 'Finish your hunt before fishing.',
  'fish.bandHint': 'Fishing Lv.{min}–{max} · selected band: Lv.{selected} · {rod}',
  'fish.rodRange': 'Up to Lv.{max}',
  'fish.rodEffect': 'Range up to Lv.{max} · does not raise your level',
  'fish.caught': 'Caught {name} Lv.{level}!',
  'fish.escaped': '{name} got away.',
  'fish.noBall': 'Out of Poké Balls — fishing paused.',
  'fish.noBaitStock': 'Out of bait — fishing paused.',
  'fish.nibble': 'A nibble… nothing this time.',
  'fish.xpLabel': 'Fishing Lv.{level} · XP {xp}',
  'fish.spotLocked': 'Needs fishing Lv.{level}',
  'fish.spotReady': 'Open',
  'fish.noBait': 'No bait',
  'fish.baitNoneHint': 'Base cast speed',
  'fish.spot.pier': 'Pier',
  'fish.spot.deepSea': 'Deep sea',
  'fish.bait.common': 'Common bait',
  'fish.bait.elite': 'Elite bait',
  'fish.mat.fins': 'Fins',
  'fish.mat.water-pendant': 'Water pendant',
  'fish.mat.pearl': 'Pearl',
  'fish.mat.dome-fossil': 'Dome Fossil',
  'fish.mat.helix-fossil': 'Helix Fossil',
  'fish.mat.old-amber': 'Old Amber',
  'systems.hubTitle': 'City systems',
  'systems.hubSub': 'Economy · retention · premium · combat',
  'raid.title': 'World Raid',
  'raid.hubSub': 'World boss',
  'raid.hubNew': 'New boss',
  'raid.hubHp': '{pct}% defeated',
  'raid.hubDefeated': 'Defeated — claim!',
  'raid.hubExpired': 'Window closed',
  'raid.hint': 'Hunt as usual: every wild KO contributes damage to the boss. No spam button — progress comes from hunting.',
  'raid.yourContrib': 'Your contribution: {value}',
  'raid.damagePct': '{pct}% HP already removed',
  'raid.statusActive': 'Active · ends in {time}',
  'raid.statusDefeated': 'Boss defeated! Claim your reward.',
  'raid.statusExpired': 'Window closed. Claim based on your contribution.',
  'raid.statusClaimed': 'Reward already claimed. A new boss is up.',
  'raid.claim': 'Claim reward',
  'raid.claimed': 'Already claimed',
  'raid.claimHintReady': 'Ready to claim — loot scales with your contribution.',
  'raid.claimHintDone': 'You already claimed this raid.',
  'raid.claimHintNoDmg': 'Defeat wilds to contribute damage before claiming.',
  'raid.claimHintActive': 'The boss is still standing. Keep hunting until HP hits zero (or the window ends).',
  'raid.claimHintWait': 'Wait for the raid to end before claiming.',
  'raid.claimOk': 'Loot: {loot}',
  'raid.timeHours': '{hours}h {mins}m',
  'raid.timeMins': '{mins}m',
  'raid.err.raid_still_active': 'The boss is still active — keep hunting.',
  'raid.err.already_claimed': 'You already claimed this raid.',
  'raid.err.no_contribution': 'No contribution — defeat wilds first.',
  'raid.err.invalid_raid': 'Invalid raid.',
  'raid.err.generic': 'Could not claim reward.',
  'npc.shop': 'Shop',
  'npc.tmShop': 'TM Shop',
  'npc.nurse': 'Nurse Joy',
  'npc.blacksmith': 'Blacksmith',
  'npc.apothecary': 'Apothecary',
  'npc.miner': 'Miner',
  'npc.fisher': 'Fisher',
  'npc.professor': 'Professor',
  'npc.questBoard': 'Quest Board',
  'npc.gymLeader': 'Gym Leader',
  'npc.clanHerald': 'Clan House',
  'npc.auctioneer': 'Auctioneer',

  'chat.aria': 'Global chat',
  'chat.world': 'World',
  'chat.trade': 'Trade',
  'chat.help': 'Help',
  'chat.online': 'Online',
  'chat.placeholder': 'Talk in World...',
  'chat.send': 'Send',
  'chat.placeholder.world': 'Talk in World...',
  'chat.placeholder.trade': 'Talk in Trade...',
  'chat.placeholder.help': 'Ask for help...',
  'chat.loading': 'Loading messages...',
  'chat.empty': 'There are no messages in this channel yet.',
  'chat.systemCapture': '{trainer} caught {name} ({tag})!',
  'chat.error': 'Could not update chat.',
  'chat.muted': 'You are muted and cannot send messages right now.',
  'chat.slowDown': 'You are sending messages too quickly.',
  'chat.blockedLanguage': 'Your message contains language that is not allowed in chat.',
  'chat.invalidAttachment': 'This item or Pokémon cannot be linked.',
  'chat.attachmentLimit': 'You can link up to {count} assets per message.',
  'chat.alreadyLinked': 'This asset is already linked.',
  'chat.linked': '{name} was linked to chat.',
  'chat.removeAttachment': 'Remove link',
  'chat.shiftToLink': 'Shift + click to link in chat',
  'chat.quantity': 'Quantity',
  'chat.moves': 'Moves',
  'chat.equipped': 'Equipped',
  'chat.partner': 'Partner',
  'chat.verified': 'Verified custody',
  'chat.verifiedHint': 'Asset verified in the server inventory when the message was sent.',
  'chat.localSnapshot': 'Snapshot of the local save published by this player.',
  'chat.previewOnly': 'Sending is disabled in visual preview.',
  'chat.previewWelcome': 'Welcome to IdleMon chat!',
  'chat.previewTrade': 'Check out this Pokémon I equipped.',
  'chat.previewHelp': 'Hover over the link to see its details.',
  'admin.open': 'Admin',
  'inv.pokemon': 'Pokémon:',
  'inv.section.pokemon': 'POKÉMON · SHIFT + CLICK TO LINK',

  'map.eyebrow': 'Explore the world',
  'map.title': 'Route map',
  'map.levelBand': 'LEVEL BAND',
  'map.close': 'Close map',
  'map.youAreHere': 'YOU ARE HERE',
  'map.region': 'REGION',
  'map.bossesSoon': 'Coming soon',
  'map.bossesTitle': 'AoE Zones',
  'map.bossesZones': 'Endgame',
  'map.bossesHint': 'Arenas and legendary Pokémon from Myst will appear here. For now, explore routes by level band.',
  'map.bossesHintActive': 'Pick a zone level and type. Mono-species packs spawn in the corners; mini-bosses summon adds.',
  'map.legendCity': 'City',
  'map.legendRoute': 'Available route',
  'map.legendPick': 'Select a route to travel',
  'map.route': 'Route {type} · {levels}',
  'map.speciesChance': '{count} species · chance per encounter',
  'map.preview': 'Preview · {hint}',
  'map.lockBand': 'Band unlocks at Lv. {level}',
  'map.lockLevel': '{type} unlocks at Lv. {level}',
  'map.lockHint': '{type} only appears from Lv. {level}.',
  'map.travelLog': 'You traveled to the {type} type route.',
  'map.arriving': 'Arriving at {type} territory...',
  'map.bosses': 'Zones',
  'map.routes': 'Routes',

  'dialog.pcEyebrow': 'Pokémon Center',
  'dialog.pcText': 'Welcome to the Pokémon Center! I can fully restore your team for free.',
  'dialog.healAll': 'Heal all Pokémon',
  'dialog.healedLog': 'The whole team was healed at the Pokémon Center.',
  'dialog.healedToast': 'Your team is fully recovered!',
  'dialog.faintedLog': '{name} fainted and was taken to the Pokémon Center. The team was healed.',
  'dialog.faintedToast': 'Your Pokémon was taken to the Pokémon Center and is recovered!',
  'dialog.shopTitle': 'Sam\'s Shop',
  'dialog.shopEyebrow': 'City shop',
  'dialog.shopSub': 'Buy supplies, sell drops and spare Pokémon.',
  'dialog.tmShopTitle': 'Sammy\'s TMs',
  'dialog.tmShopIntro': 'TMs are not sold. All 18 can drop from regular encounters in advanced zones, with a higher weight for the zone type. Each disk is consumed when taught and can only be used on a Pokémon at Lv. 100 or higher.',
  'dialog.tmDropOnly': 'All 18 TMs are obtained only as drops from encounters in advanced zones.',
  'dialog.tmDropOnlyShort': 'Advanced-zone drop',
  'dialog.dropOnlyItem': 'This item can only be obtained as a drop from an advanced zone.',
  'dialog.tmEffect': '{type} area move · requires Pokémon Lv.{level}',
  'dialog.closeShop': 'Close shop',
  'dialog.qty': 'Quantity',
  'dialog.ivFrom': 'from',
  'dialog.ivTo': 'to',
  'dialog.ivMin': 'Min IV (0–186)',
  'dialog.ivMax': 'Max IV (0–186)',
  'dialog.buy': 'Buy',
  'dialog.sell': 'Sell',
  'dialog.sellTotal': 'Total ({count})',
  'dialog.pokemon': 'Pokémon',
  'dialog.noDrops': 'No drops to sell yet.',
  'dialog.noPokemonFilter': 'No Pokémon match the filters.',
  'dialog.pickItem': 'Select at least one item.',
  'dialog.pickPokemon': 'Select at least one Pokémon.',
  'dialog.bought': 'Bought {qty}× {name}.',
  'dialog.soldDrops': 'Sold for {total} IdleCoin!',
  'dialog.soldPokemon': 'Sold {count} Pokémon for {total} IdleCoin!',
  'dialog.noCoins': 'Not enough IdleCoin.',
  'dialog.inStock': 'owns {qty}',
  'dialog.stockLine': '{qty}× in stock · {total}',
  'dialog.onTeam': 'on team',
  'dialog.lockSale': 'Lock sale',
  'dialog.unlockSale': 'Unlock sale',

  'evo.eyebrow': 'Evolution available',
  'evo.title': 'Evolve Pokémon',
  'evo.sub': 'Choose how to evolve. IVs and rarity are always kept.',
  'evo.fromAlt': 'Current form',
  'evo.toAlt': 'Next evolution',
  'evo.warning': 'On a normal evolution, the Pokémon returns to level 1. IVs and rarity are kept.',
  'evo.normal': 'Evolve and return to level 1',
  'evo.coins': 'Keep level with IdleCoin',
  'evo.coinCost': '{cost} IdleCoin to keep level {level}',
  'evo.notEnoughCoins': 'Not enough IdleCoin for this evolution.',
  'evo.canEvolve': '{name} can evolve!',
  'evo.toast': '{from} evolved into {to}!',
  'common.yes': 'Yes',
  'common.no': 'No',
  'mastery.leveled': '{name} reached Mastery {level}!',
  'capture.hpChance': '{hp}% HP · {pct}% chance',
  'battle.initiative': 'Initiative',
  'battle.captureWindow': 'Capture window',
  'progress.eyebrow': 'Advanced progression',
  'progress.title': 'Trainer and Prestige',
  'progress.sub': 'Account perks, XP path and Prestige reset.',
  'progress.perksEyebrow': 'Account perks',
  'progress.prestige': 'Prestige trainer',
  'progress.prestigeShort': 'Prestige {count}',
  'progress.ready': 'Ready for Prestige',
  'progress.xp': '{current} / {max} XP',
  'progress.offlineTraining': 'Offline training',
  'progress.reserveVip': 'Reserve (VIP)',
  'progress.loot': 'Extra loot',
  'progress.capture': 'Capture bonus',
  'progress.xpBonus': 'Total XP bonus',
  'progress.offlineCap': 'Offline cap',
  'progress.mastery': 'Mastery unlocked',
  'progress.note': 'Prestige resets the current level, but keeps routes and Mastery. Each Prestige grants 2% XP, 1 offline hour, 1 Specialization point and 1 free respec.',
  'progress.maxPrestige': 'Maximum Prestige reached',
  'progress.requires300': 'Requires trainer level 300',
  'progress.confirm': 'Prestige now? Your trainer returns to level 1, while routes and Mastery stay unlocked.',
  'progress.completed': 'Trainer Prestige {count} reached!',
  'progress.openSpecialization': 'Open Specialization',
  'specialization.close': 'Close Specialization',
  'specialization.eyebrow': 'Streak Points',
  'specialization.title': 'Streak Points',
  'specialization.intro': 'Invest talent points and track defeats. Level milestones and Prestige grant points; veterancy grows every 1,000 kills.',
  'specialization.statsEyebrow': 'Overview',
  'specialization.investEyebrow': 'Invest',
  'specialization.available': 'available points',
  'specialization.allocated': 'allocated points',
  'specialization.prestigeCount': 'Prestige rank',
  'specialization.stat.totalKills': 'Total kills',
  'specialization.stat.available': 'Available points',
  'specialization.stat.used': 'Used points',
  'specialization.stat.nextPoint': 'Next milestone in',
'specialization.streakNote': '1 Streak Point every 1,000 kills · investible points come from defeat milestones',
  'specialization.streak.exp': 'EXP',
  'specialization.streak.loot': 'LOOT',
  'specialization.streak.catch': 'CATCH',
  'specialization.streak.shiny': 'SHINY',
  'specialization.streakValuePct': '+{value}%',
  'specialization.streakValueReserve': '{value}% reserve',
  'specialization.streakPer.exp': '+{value} p.p. reserve XP per point',
  'specialization.streakPer.loot': '+{value}% loot per point',
  'specialization.streakPer.catch': '+{value}% catch chance per point',
  'specialization.streakPer.shiny': '+{value}% shiny research progress per point',
  'specialization.pointsInPath': '{count} point(s)',
  'specialization.investPlus': '+ Invest',
  'specialization.killsEyebrow': 'History',
  'specialization.killsTitle': 'Kills per Pokémon',
  'specialization.killsEmpty': 'No kills recorded yet. Defeat wilds on hunts to fill this grid.',
  'specialization.killEyebrow': 'Combat veterancy',
  'specialization.killBonus': '+{value}% XP from defeats',
  'specialization.killMax': 'Maximum bonus reached with {kills} enemies defeated.',
  'specialization.killNext': '{kills} defeats. {remaining} remain until the {next} milestone.',
  'specialization.shinyEyebrow': 'Shiny research',
  'specialization.shinyTitle': 'The same rule for every species',
  'specialization.shinyRule': 'Each species tracks its own defeats. Soft pity starts at {start} and grows up to the cap, with no guaranteed Shiny.',
  'specialization.shinyBase': 'base chance',
  'specialization.shinyPity': 'soft pity starts',
  'specialization.shinyCapLabel': 'chance cap',
  'specialization.shinyResearchBonus': 'Current Researcher: +{value}% progress per defeat',
  'specialization.path': 'Path',
  'specialization.next': 'Next',
  'specialization.maxRank': 'Maximum rank',
  'specialization.maxed': 'Complete',
  'specialization.invest': 'Invest 1 point',
  'specialization.trainer.name': 'Mentor',
  'specialization.trainer.description': 'Your equipped partner keeps training while the game is closed.',
  'specialization.hunter.name': 'Hunter',
  'specialization.hunter.description': 'Improves the amount of materials earned while hunting.',
  'specialization.catcher.name': 'Catcher',
  'specialization.catcher.description': 'Raises the final chance of every capture attempt.',
  'specialization.researcher.name': 'Researcher',
  'specialization.researcher.description': 'Speeds up species-specific Shiny research.',
  'specialization.effect.trainer': 'Partner trains offline at {offline}% of the pace',
  'specialization.effect.hunter': '+{value}% loot',
  'specialization.effect.catcher': '+{value}% capture chance',
  'specialization.effect.researcher': '+{value}% Shiny progress',
  'specialization.respecFree': 'Free respec ({count})',
  'specialization.respecCost': 'Respec for {cost} IdleCoin',
  'specialization.systemsEyebrow': 'Where are the other systems?',
  'specialization.systemsTitle': 'Active progression systems',
  'specialization.system.prestige': 'Prestige',
  'specialization.system.prestigeWhere': 'Trainer profile · after level 300',
  'specialization.system.mastery': 'Mastery',
  'specialization.system.masteryWhere': 'My Pokémon · levels above 300',
  'specialization.system.evolution': 'Evolution',
  'specialization.system.evolutionWhere': 'My Pokémon · upon reaching its required level',
  'specialization.system.offline': 'Offline hunting',
  'specialization.system.offlineWhere': 'Automation · requires a 5 min active sample',
  'specialization.system.research': 'Research, quality and drops',
  'specialization.system.researchWhere': 'Pokédex · each species detail',
  'specialization.system.combat': 'Speed and initiative',
  'specialization.system.combatWhere': 'Hunt · independent clocks per combatant',
  'specialization.confirmInvest': 'Invest in {name}? The next effect will be: {effect}.',
  'specialization.invested': '{name} advanced to rank {rank}.',
  'specialization.noPointsServer': 'The server has not recorded an available Streak Point yet. Wait for the hunt to sync and try again.',
  'specialization.notEnoughCoins': 'Not enough IdleCoin to respec Specialization.',
  'specialization.confirmRespecFree': 'Reset all points using one free respec?',
  'specialization.confirmRespecCost': 'Reset all points for {cost} IdleCoin?',
  'specialization.respecced': 'Specialization points reset.',
  'specialization.killMilestoneLog': '{kills} enemies defeated: permanent XP bonus reached +{value}%.',
  'specialization.killMilestoneToast': 'Veterancy: +{value}% permanent XP!',
  'offline.title': 'Offline hunt',
  'offline.hint': 'Rest during a hunt to arm offline rewards',
  'offline.requirement': 'Requires 5 minutes of an active hunt to form a sample.',
  'offline.start': 'Start offline hunt',
  'offline.rest': 'Rest',
  'offline.restHint': 'Stop the hunt and arm offline rewards. Without this, closing the game pays nothing.',
  'offline.restReady': 'Hunt active: press Rest to arm offline and close the game.',
  'offline.restIdle': 'Start a hunt and press Rest to arm offline. Closing without resting pays nothing.',
  'offline.restNeedHunt': 'Start a hunt before resting.',
  'offline.restArmed': 'Offline armed. You can close the game — come back later to collect.',
  'offline.restArmedRisk': 'Offline armed with no potions/revive: the sample stops early if your partner falls.',
  'offline.restArmFailed': 'Could not arm offline. Try again.',
  'offline.faintedNoSupplies': 'Your partner fainted with no potion/revive. The hunt sample stopped.',
  'offline.pending': 'Rewards are ready to collect.',
  'offline.active': 'Offline hunt is active. Return later to collect it.',
  'offline.ready': 'Sample ready: {time} of active hunt.',
  'offline.sampling': 'Sampling the hunt: {time} / 05:00.',
  'offline.notReady': 'Hunt for at least 5 minutes before going offline.',
  'offline.started': 'Offline hunt started. Current cap: {hours}h.',
  'offline.reportEyebrow': 'Offline report',
  'offline.reportTitle': 'The hunt continued',
  'offline.claim': 'Collect rewards',
  'offline.time': 'offline time',
  'offline.efficiency': 'Rewards use 50% of the last 10-minute combat sample. Captures, stones and rare rolls are disabled offline.',
  'offline.noDrops': 'No stable drops were generated in this period.',
  'offline.claimed': 'Offline rewards collected!',
  'offline.serverEfficiency': 'Welcome back! Your hunt kept earning while you were away, at {pct} of your farm rate. Captures happen while you are playing.',
  'offline.trainerXp': 'Trainer XP',
  'offline.pokemonXp': 'Partner XP',
  'offline.pokemonShare': 'Your partner trained offline at {pct}% of the pace, thanks to Mentor/VIP.',
  'offline.pokemonLocked': 'Your partner does not train offline. Invest in Mentor (Specialization) or activate VIP to unlock up to 75% of the XP.',
  'offline.reserveShare': 'The rest of your equipped team trained too: +{xp} XP each (VIP).',
  'offline.reserveNone': 'No reserve Pokémon earned XP this period.',
  'offline.reserveVipOnly': 'The reserve only trains offline with VIP (10% of partner XP).',
  'offline.stopLabel': 'Stopped because',
  'offline.stop.rest': 'you rested on purpose',
  'offline.stop.rest_at_risk': 'you rested with no potions/revive',
  'offline.stop.supplies_exhausted': 'potions/revive ran out — the offline sample stopped early',
  'offline.stop.fainted_no_supplies': 'your partner fainted with no potion/revive',
  'offline.gotIt': 'Got it',
  'offline.serverDisabled': 'Offline is disabled with server progress (prevents ghost XP/loot).',
  'dex.captureDifficulty': 'Difficulty',
  'dex.possibleDrops': 'Possible drops',
  'dex.dropHint': 'Each item rolls independently per defeat, with a quantity range.',
  'dex.drop.primaryRole': 'Primary drop',
  'dex.drop.secondaryRole': 'Secondary drop',
  'dex.drop.signatureRole': 'Special drop',
  'dex.drop.stoneRole': 'Evolution stone',
  'dex.drop.lootRole': 'Loot',
  'dex.noDrops': 'This species has no configured drops.',

  'auth.eyebrow': 'TRAINER ACCOUNT',
  'auth.title': 'Enter the world of IdleMon',
  'auth.intro': 'Your account protects your identity and prepares your access to the Global Market.',
  'auth.registerTab': 'Create account',
  'auth.loginTab': 'Sign in',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'you@example.com',
  'auth.loginIdentifier': 'Email or username',
  'auth.loginIdentifierPlaceholder': 'you@example.com or YourTrainer',
  'auth.trainerName': 'Username',
  'auth.trainerNamePlaceholder': 'YourTrainer',
  'auth.trainerNameHint': '3–16 characters: letters, numbers, or _',
  'auth.password': 'Password',
  'auth.passwordPlaceholder': 'At least 8 characters',
  'auth.passwordConfirmation': 'Confirm password',
  'auth.passwordConfirmationPlaceholder': 'Repeat your password',
  'auth.passwordLoginPlaceholder': 'Your password',
  'auth.rulesAcceptPrefix': 'I have read and accept the',
  'auth.rulesLink': 'Game Rules',
  'auth.version': 'version',
  'auth.create': 'Create my account',
  'auth.login': 'Enter the game',
  'auth.forgotPassword': 'I forgot my password',
  'auth.resetIntro': 'Enter your account email to receive a secure recovery link.',
  'auth.sendReset': 'Send recovery link',
  'auth.backToLogin': 'Back to sign in',
  'auth.newPasswordIntro': 'Create a new password to recover your account.',
  'auth.newPassword': 'New password',
  'auth.saveNewPassword': 'Save new password',
  'auth.sendingReset': 'Sending recovery link…',
  'auth.resetSent': 'If that email is registered, a recovery link will arrive shortly.',
  'auth.savingPassword': 'Saving your new password…',
  'auth.passwordUpdated': 'Password updated. Sign in again with your new password.',
  'auth.recoveryReady': 'Link verified. Choose your new password.',
  'auth.betaNote': 'Beta environment: progress is still saved in this browser.',
  'auth.rulesClose': 'Close rules',
  'auth.rulesEyebrow': 'GAME RULES',
  'auth.rulesTitle': 'Preliminary beta rules',
  'auth.rulesDraftNote': 'This text is preliminary. The final rules will be published before open beta and will require acceptance of a new version.',
  'auth.rulesDraftVersion': 'Preliminary version {version}',
  'auth.rulesVersion': 'Version {version}',
  'auth.account': 'Account',
  'auth.signOut': 'Sign out',
  'auth.creating': 'Creating your account…',
  'auth.entering': 'Signing in…',
  'auth.loading': 'Checking your session…',
  'auth.verifyingEmail': 'Confirming your account…',
  'auth.verifyingRecovery': 'Checking your recovery link…',
  'auth.confirmationSent': 'Account created, but it is not active yet. We sent a link to {email}. Open the email and confirm your account before signing in.',
  'auth.emailPendingActivation': 'This account was already created, but it has not been activated yet. We sent a new link to {email}. Open the email and confirm your account before signing in.',
  'auth.emailConfirmed': 'Account confirmed successfully! Just sign in now.',
  'auth.errorNameUnavailable': 'That username is already in use or reserved.',
  'auth.errorNameInvalid': 'Use 3 to 16 letters, numbers, or _ in your username.',
  'auth.errorRules': 'You must read and accept the Game Rules.',
  'auth.errorEmailExists': 'This email already has an active account. Sign in with your email and password or use “Forgot password”.',
  'auth.errorEmailRate': 'Too many email delivery attempts. Wait a few minutes and try again.',
  'auth.errorCredentials': 'Incorrect email, username, or password.',
  'auth.errorLoginRate': 'Too many login attempts. Wait a few minutes and try again.',
  'auth.errorEmailUnconfirmed': 'Your account is not active yet. Open the confirmation link we emailed you before signing in.',
  'auth.errorLinkExpired': 'This confirmation link has expired or was already used. Go back to “Create account”, sign up with the same email and we will send a new link.',
  'auth.errorRecoveryExpired': 'This recovery link has expired or was already used. Request a new one under “Forgot my password”.',
  'auth.errorProfileMissing': 'You are signed in, but your trainer profile was not found. Reload the page; if it persists, contact support.',
  'auth.errorUserBanned': 'This account is suspended. Contact support for details.',
  'auth.errorSignupDisabled': 'Account creation is temporarily closed. Please try again later.',
  'auth.errorSamePassword': 'Your new password must be different from the previous one.',
  'auth.errorCaptcha': 'Complete the security check and try again.',
  'auth.errorNetwork': 'The server could not be reached. Check your connection.',
  'auth.errorGeneric': 'The operation could not be completed. Try again.',
  'auth.errorIpLimit': 'Too many accounts were created from your network (same IP). For security, wait 24 hours and try again.',
  'auth.errorServerInternal': 'The server hit an error while processing your account. Try again; if it persists, contact support.',
  'auth.errorEmailSend': 'The confirmation email could not be sent to this address. Try again in a few minutes; if it persists, contact support.',
  'auth.errorPasswordWeak': 'This password has appeared in data leaks and is easy to guess. Choose a different one, mixing letters, numbers, and symbols.',
  'auth.checkingName': 'Checking availability…',
  'auth.nameAvailable': 'Username available!',
  'auth.errorEmail': 'Enter a valid email address.',
  'auth.errorPassword': 'Your password must contain at least 8 characters.',
  'auth.errorPasswordMatch': 'The passwords do not match.',
  'auth.errorBackend': 'The account service is not available yet. Try again shortly.',
  'auth.sessionSuperseded': 'Your account signed in on another device. This session was closed.',
  'auth.sessionRequired': 'Invalid session. Please sign in again.',
  'auth.sessionConflictEyebrow': 'ACTIVE SESSION FOUND',
  'auth.sessionConflictTitle': 'Your account is already open in another browser',
  'auth.sessionConflictBody': 'To protect your progress, only one browser can play with this account at a time.',
  'auth.sessionConflictNote': 'You can take over in this browser or keep the session that is already open. Neither option keeps two games active.',
  'auth.sessionConflictKeep': 'Keep existing session',
  'auth.sessionConflictTakeover': 'Play in this browser',
  'auth.sessionConflict': 'Another session is active. Choose which browser should continue.',
  'auth.sessionConflictKept': 'The existing session was kept. This browser was signed out.',
  'auth.sessionConflictChanged': 'The active session changed while you were deciding. Choose again.',

  'starter.eyebrow': 'Your journey starts now',
  'starter.title': 'Choose your starter Pokémon',
  'starter.hint': 'They will lead your team on hunts. Others join through capture.',
  'starter.step1Title': 'Choose your trainer',
  'starter.step1Hint': 'Pick a look and paint each clothing piece.',
  'starter.step2Title': 'Choose your starter Pokémon',
  'starter.step2Hint': 'They will lead your team on hunts. Others join through capture.',
  'starter.step3Title': 'Choose your starter Pokémon',
  'starter.step3Hint': 'They will lead your team on hunts. Others join through capture.',
  'starter.save': 'Your progress is saved in this browser.',
  'starter.picked': '{name} is now your partner!',
  'starter.chosen': '✓ Chosen',
  'starter.regionTitle': 'Choose a region',
  'starter.region.kanto': 'Kanto',
  'starter.region.johto': 'Johto',
  'starter.region.hoenn': 'Hoenn',
  'starter.region.sinnoh': 'Sinnoh',
  'starter.trainerTitle': 'Choose your trainer',
  'starter.lookTitle': 'Choose a look',
  'starter.colorsTitle': 'Clothing colors',
  'starter.colorsHint': 'Each slot tints a fabric region of this look. The character\'s skin stays untouched.',
  'starter.color.head': 'Hair / accessory',
  'starter.color.body': 'Main outfit',
  'starter.color.legs': 'Secondary outfit',
  'starter.color.feet': 'Detail / footwear',
  'starter.boy': 'Boy',
  'starter.girl': 'Girl',
  'starter.nameLabel': 'Trainer name',
  'starter.namePlaceholder': 'Your name',
  'starter.next': 'Next',
  'starter.back': 'Back',
  'starter.start': 'Start the journey',
  'starter.needStarter': 'Pick a starter Pokémon.',
  'starter.needLook': 'Pick a trainer look.',
  'starter.needName': 'Enter a name (2–16 characters).',
  'starter.grassPoison': 'GRASS · POISON',
  'starter.fire': 'FIRE',
  'starter.water': 'WATER',
  'starter.initialMove': 'Initial move',

  'looks.trainer': 'Trainer',
  'looks.elite': 'Elite',
  'looks.adventurer': 'Adventurer',
  'looks.atletic': 'Athletic',
  'looks.punk': 'Punk',
  'looks.mercenary': 'Mercenary',
  'looks.catcher': 'Catcher',
  'looks.rapper': 'Rapper',
  'looks.jamaican': 'Jamaican',
  'looks.oriental': 'Oriental',
  'looks.rocket': 'Rocket',
  'looks.business': 'Business',
  'looks.fisher': 'Fisher',
  'looks.hiker': 'Hiker',
  'looks.police': 'Officer',
  'looks.veteran': 'Veteran',
  'looks.psychic': 'Psychic',

  'log.ready': 'The journey is ready to begin.',
  'log.leveled': '{name} reached level {level}.',
  'log.trainerLeveled': 'You reached level {level}.',
  'log.learned': 'learned {move}.',
  'log.lootReceived': 'Loot received: {items}',
  'log.learnedToast': '{name} learned {move}!',
  'log.defeatedXp': 'defeated · +{xp} EXP',
  'log.defeatedDrop': 'defeated · +{xp} EXP · drop: {drops}',
  'log.defeatedRare': 'defeated · +{xp} EXP · 💎 rare drop: {drops}',
  'log.rareToast': '💎 Rare! {name} dropped {item}!',
  'log.notVip': '{name} is not in the VIP filter.',
  'log.noBall': 'You have no {ball} available.',
  'log.noBallToast': 'No {ball} in inventory.',
  'log.escaped': '{name} broke free from the {ball} ({chance}% · {difficulty}).',
  'log.noEncounter': '{name} left the server queue — capture cancelled (no ball spent).',
  'log.noEncounterToast': 'Encounter still syncing. Try again in a moment.',
  'log.ghostRestored': '{count} rare capture(s) restored from history.',
  'log.captured': 'caught at level {level}! {rarity} · IV {iv}',
  'log.capturedToast': '{name} caught at level {level} · {rarity}!',
  'log.potionUsed': '{name} used {item} (+{hp} HP).',
  'log.reviveUsed': '{name} came back with a Revive!',
  'log.sold': 'sold · +{total} IdleCoin',
  'log.partnerSeeking': '{name} · Your Pokémon',

  'toast.pickPotion': 'Select an available potion in the auto-potion panel.',
  'toast.potionUsed': '{name} used!',
  'toast.emptyPotion': 'No potions in inventory. Buy some at the shop.',
  'toast.revived': 'Revive used — the hunt continues!',

  'types.elétrico': 'Electric',
  'types.fogo': 'Fire',
  'types.água': 'Water',
  'types.planta': 'Grass',
  'types.inseto': 'Bug',
  'types.voador': 'Flying',
  'types.normal': 'Normal',
  'types.psíquico': 'Psychic',
  'types.pedra': 'Rock',
  'types.terra': 'Ground',
  'types.fantasma': 'Ghost',
  'types.dragão': 'Dragon',
  'types.lutador': 'Fighting',
  'types.veneno': 'Poison',
  'types.sombrio': 'Dark',
  'types.aço': 'Steel',
  'types.gelo': 'Ice',
  'types.fada': 'Fairy',

  'rarities.Comum': 'Common',
  'rarities.Incomum': 'Uncommon',
  'rarities.Raro': 'Rare',
  'rarities.Épico': 'Epic',
  'rarities.Lendário': 'Legendary',
  'rarities.Mítico': 'Mythical',
  'rarities.Celestial': 'Celestial',
  'rarities.Ancião': 'Ancient',
  'rarities.Secreto': 'Secret',
  'rarities.Inicial': 'Starter',

  'catch.easy': 'Easy',
  'catch.medium': 'Medium',
  'catch.hard': 'Hard',
  'catch.veryHard': 'Very hard',

  'maps.saffron-meadows': 'Saffron Meadows',
  'maps.viridian-trail': 'Viridian Trail',
  'maps.pewter-forest': 'Pewter Forests',
  'maps.pewter-woods': 'Pewter Woods',
  'maps.rock-tunnel-swamp': 'Rock Tunnel Swamps',
  'maps.rock-tunnel-caves': 'Rock Tunnel Caves',
  'maps.cinnabar-volcano': 'Cinnabar Volcano',
  'maps.cinnabar-ashes': 'Cinnabar Ashes',
  'maps.sevii-islands': 'Legendary Isles',
  'maps.glacial-sea': 'Glacial Sea',
  'maps.supreme-threshold': 'Supreme Threshold',
  'maps.ashen-spire': 'Ashen Spire',
  'maps.obsidian-court': 'Obsidian Court',
  'maps.eclipse-rift': 'Eclipse Rift',
  'maps.final-horizon': 'Final Horizon',

  'items.pokeball.name': 'Poké Ball',
  'items.pokeball.desc': '1× catch rate.',
  'items.old-rod.name': 'Old Rod',
  'items.old-rod.desc': 'Catches basic aquatic Pokémon (bands up to Lv.40).',
  'items.good-rod.name': 'Good Rod',
  'items.good-rod.desc': 'Catches aquatic Pokémon up to mid bands (Lv.150).',
  'items.super-rod.name': 'Super Rod',
  'items.super-rod.desc': 'Catches aquatic Pokémon on any level band.',
  'items.greatball.name': 'Great Ball',
  'items.greatball.desc': '2× catch rate.',
  'items.superball.name': 'Super Ball',
  'items.superball.desc': '3× catch rate.',
  'items.ultraball.name': 'Ultra Ball',
  'items.ultraball.desc': '4× catch rate.',
  'items.masterball.name': 'Master Ball',
  'items.masterball.desc': '100× catch rate. Always catches.',
  'items.potion.name': 'Potion',
  'items.potion.desc': 'Restores 30% of a Pokémon\'s HP.',
  'items.great-potion.name': 'Super Potion',
  'items.great-potion.desc': 'Restores 60% of a Pokémon\'s HP.',
  'items.ultra-potion.name': 'Hyper Potion',
  'items.ultra-potion.desc': 'Restores 80% of a Pokémon\'s HP.',
  'items.hyper-potion.name': 'Max Potion',
  'items.hyper-potion.desc': 'Restores 90% of a Pokémon\'s HP.',
  'items.full-restore.name': 'Full Restore',
  'items.full-restore.desc': 'Fully restores a Pokémon\'s HP.',
  'items.medicine.name': 'Antidote',
  'items.medicine.desc': 'Cures a Pokémon\'s poison.',
  'items.revive.name': 'Revive',
  'items.revive.desc': 'Revives a fainted Pokémon.',
  'items.leaf-stone.name': 'Leaf Stone',
  'items.leaf-stone.desc': 'Evolves Grass-type Pokémon.',
  'items.water-stone.name': 'Water Stone',
  'items.water-stone.desc': 'Evolves Water-type Pokémon.',
  'items.thunder-stone.name': 'Thunder Stone',
  'items.thunder-stone.desc': 'Evolves Electric-type Pokémon.',
  'items.fire-stone.name': 'Fire Stone',
  'items.fire-stone.desc': 'Evolves Fire-type Pokémon.',
  'items.sun-stone.name': 'Sun Stone',
  'items.sun-stone.desc': 'Evolves sun-loving Pokémon.',
  'items.moon-stone.name': 'Moon Stone',
  'items.moon-stone.desc': 'Moon reference. Evolves some Pokémon.',
  'items.ice-stone.name': 'Ice Stone',
  'items.ice-stone.desc': 'Evolves Ice-type Pokémon.',
  'items.shiny-stone.name': 'Shiny Stone',
  'items.shiny-stone.desc': 'Evolves shiny Pokémon.',
  'items.venom-stone.name': 'Poison Stone',
  'items.venom-stone.desc': 'Evolves Poison-type Pokémon.',
  'items.rock-stone.name': 'Rock Stone',
  'items.rock-stone.desc': 'Evolves Rock-type Pokémon.',
  'items.punch-stone.name': 'Punch Stone',
  'items.punch-stone.desc': 'Evolves Fighting-type Pokémon.',
  'items.cocoon-stone.name': 'Cocoon Stone',
  'items.cocoon-stone.desc': 'Evolves cocoon Pokémon.',
  'items.crystal-stone.name': 'Crystal Stone',
  'items.crystal-stone.desc': 'Evolves crystal Pokémon.',
  'items.darkness-stone.name': 'Darkness Stone',
  'items.darkness-stone.desc': 'Evolves Dark-type Pokémon.',
  'items.earth-stone.name': 'Earth Stone',
  'items.earth-stone.desc': 'Evolves Ground-type Pokémon.',
  'items.enigma-stone.name': 'Enigma Stone',
  'items.enigma-stone.desc': 'Evolves Psychic-type Pokémon.',
  'items.heart-stone.name': 'Heart Stone',
  'items.heart-stone.desc': 'Evolves Fairy-type Pokémon.',
  'items.drop-electric-box.name': 'Electric Box',
  'items.drop-essence-fire.name': 'Fire Essence',
  'items.drop-water-gem.name': 'Water Gem',
  'items.drop-seed.name': 'Seed',
  'items.drop-bug-antenna.name': 'Bug Antenna',
  'items.drop-feather.name': 'Feather',
  'items.drop-tooth.name': 'Tooth',
  'items.drop-twisted-spoon.name': 'Twisted Spoon',
  'items.drop-stone-orb.name': 'Stone Orb',
  'items.drop-bone.name': 'Bone',
  'items.drop-ghost-trace.name': 'Ghost Trace',
  'items.drop-dragon-tooth.name': 'Dragon Fang',
  'items.drop-champion-belt.name': 'Champion Belt',
  'items.drop-poison-bottle.name': 'Poison Bottle',
  'items.drop-fox-tail.name': 'Fox Tail',
  'items.drop-iron-pin.name': 'Iron Pin',
  'items.drop-ice-orb.name': 'Ice Orb',
  'items.drop-luck-medal.name': 'Luck Medal',
  'toast.removeFromTeam': "Remove the Pokémon from the team before selling.",
  'toast.nothingToSell': "Nothing to sell.",
  'toast.sellStockMismatch': "Inventory was out of sync with the server. Quantities refreshed — try selling again.",
  'toast.noEligiblePokemon': "No eligible Pokémon to sell.",
  'toast.unlockToSell': "Unlock the padlock (sync) and try selling again.",
  'toast.sellPokemonBatch': "Too many Pokémon selected. Try again — sales are sent in batches.",
  'toast.teamFull': "Your team already has six Pokémon. Remove a reserve first.",
  'toast.teamSyncFailed': "Failed to save the team on the server.",
  'toast.cannotEvolveYet': "This Pokémon cannot evolve yet.",
  'toast.evolutionUnavailable': "Evolution is no longer available.",
  'toast.stoneUnavailable': "That stone is not available.",
  'team.movesPending': "Pending changes",
  'team.movesSaved': "Moves saved",
  'team.levelLabel': "Level {level}",
  'team.status': "STATS",
  'auto.potionStock': "{count} potion(s) available",
  'auto.potionNone': "No potions in inventory.",
  'battle.turnEnemy': "Enemy turn",
  'battle.turnPlayer': "Your turn",
  'map.unlockAt': "Unlocks at level {level}",
  'map.routeUnlocked': "Route unlocked",
  'log.soldFor': "sold for {total} IdleCoin.",
  'log.soldCoins': "sold · +{total} IdleCoin",
  'log.soldMany': "sold {count} · +{total} IdleCoin",
  'dialog.shop': "Shop",
  'col.empty': "No Pokémon captured yet.<br>Enable auto-capture and adventure on a route.",
  'col.noMatch': "No Pokémon match the filters.<br>Adjust or clear the filters above.",
  'col.equip': "Add to team",
  'col.unequip': "Remove from team",
  'col.equippedToast': "{name} was added to the team!",
  'col.removedToast': "{name} was removed from the team.",
  'col.detailStatus': "Stats · Lv. {level}",
  'evo.titleName': "Evolve {name}",
  'sys.pixiOn': "PixiJS renderer active — Saffron in tiles.",
  'sys.pixiOff': "Pixi unavailable — using PNG.",
  'sys.bootDegraded': "Part of the loading failed. Reload (F5) if something stops responding.",
  'sys.movesFail': "Moves: failed to load data.",
  'sys.updateAvailable': 'A new version is available — the game will refresh shortly.',
  'sys.updateNow': 'Update now',
  'sys.collisionFail': "Detailed city collision unavailable.",
  'battle.goingTo': "{attacker} GOING TO {target}",
  'battle.fightingWith': "{attacker} FIGHTING {target}",
  'battle.fallbackAttack': "Attack",
  'battle.unaffected': "no effect",
  'battle.superEffective': "Super effective!",
  'battle.notEffective': "Not very effective...",
  'hunt.territory': "{type} territory",
  'hunt.levelPokemon': "Level {level} Pokémon",
  'team.equippedMoves': "EQUIPPED MOVES",
  'team.makePrincipal': "Make {name} the main Pokémon",
  'team.equipAsPrincipal': "Equip as main",
  'team.principal': "MAIN POKÉMON",
  'team.promotedToast': "{name} is now your main Pokémon!",
  'team.movesHint': "Equip up to four moves. In combat, the Pokémon automatically uses the best ready move; used moves recharge in turns.",
  'moves.oneTurn': "1 turn",
  'moves.turns': "{count} turns",
  'moves.alwaysReady': "Always ready",
  'moves.ready': "READY",
  'moves.rechargeLabel': "Cooldown: {turns}",
  'moves.rotationAria': "Equipped moves and turn cooldowns",
  'team.ivsTotal': "Total {value}",
  'col.resultsOf': "{filtered} of {total} Pokémon",
  'col.ivsTotal': "IVs · total {value}",
  'market.title': "Global Market",
  'market.subtitle': "Buy, sell, and trade with players from around the world.",
  'market.tab.buy': "Buy",
  'market.tab.sell': "List",
  'market.tab.mine': "My listings",
  'market.categories': "Categories",
  'market.category.all': "All",
  'market.category.item': "Items",
  'market.category.stone': "Stones",
  'market.category.ball': "Poké Balls",
  'market.category.loot': "Resources",
  'market.category.pokemon': "Pokémon",
  'market.searchPlaceholder': "Search item or Pokémon...",
  'market.sort': "Sort",
  'market.sort.recent': "Newest",
  'market.sort.priceAsc': "Lowest price",
  'market.sort.priceDesc': "Highest price",
  'market.clear': "Clear",
  'market.cards': "Cards",
  'market.rows': "Rows",
  'market.filters': "Advanced filters",
  'market.any': "Any",
  'market.filter.currency': "Currency",
  'market.filter.ivMin': "Minimum IV",
  'market.filter.ivMax': "Maximum IV",
  'market.filter.levelMin': "Minimum level",
  'market.filter.levelMax': "Maximum level",
  'market.filter.type': "Type",
  'market.filter.rarity': "Rarity",
  'market.filter.shiny': "Shiny only",
  'market.currency': "Currency",
  'market.currency.idlecoin': "IdleCoin",
  'market.currency.emerald': "Emerald",
  'market.item': "Item",
  'market.items': "Items · Poké Balls · Resources",
  'market.pokemon': "Pokémon",
  'market.groupSummary': "{qty}× · {sellers} sellers",
  'market.fromPrice': "from {price} {currency}/ea",
  'market.offerOnly': "Offers only",
  'market.power': "Power",
  'market.details': "Listing details",
  'market.selectListing': "Select a listing to see its details.",
  'market.level': "Level",
  'market.unitPrice': "Unit price",
  'market.quantity': "Quantity",
  'market.total': "Total",
  'market.multipleSellers': "{count} sellers available",
  'market.seller': "Seller",
  'market.buyNow': "Buy now",
  'market.makeOffer': "Make offer",
  'market.showing': "Showing {start}–{end} of {total} results",
  'market.noResults': "No listings found",
  'market.noResultsHint': "Adjust the filters or try another search.",
  'market.deliveriesReady': "{count} delivery item(s) ready",
  'market.claimNow': "Claim now",
  'market.deliveriesClaimed': "Deliveries claimed into your save.",
  'market.sellTitle': "List on the Market",
  'market.sellSubtitle': "Choose an asset from your save or custody and set its terms.",
  'market.localSave': "Local save",
  'market.inCustody': "In custody",
  'market.selectAsset': "Select an item or Pokémon to list.",
  'market.listAsset': "Listing setup",
  'market.onlyOffers': "Offers only",
  'market.allowOffers': "Allow offers",
  'market.fee': "Fee ({percent}%)",
  'market.custodyWarning': "The Pokémon stays in custody, outside your team and storage, until it sells or is cancelled.",
  'market.depositWarning': "The asset will move to secure custody before it is listed.",
  'market.listPokemon': "List Pokémon",
  'market.listNow': "List now",
  'market.withdraw': "Withdraw from custody",
  'market.noItems': "No eligible items.",
  'market.noPokemon': "No eligible Pokémon.",
  'market.myListings': "My listings",
  'market.myListingsSubtitle': "Track stock, price, and pending offers.",
  'market.noListings': "You have no active listings.",
  'market.pendingOffer': "Offer pending",
  'market.active': "Active",
  'market.cancel': "Cancel",
  'market.secureCustody': "Server-protected custody and settlement",
  'market.pulseActive': 'Active',
  'market.pulseRequests': 'Requests',
  'market.pulseOffers': 'Offers',
  'market.pulseProtected': 'protected custody',
  'market.purchaseComplete': "Purchase complete. Your delivery is ready.",
  'market.listingCreated': "Listing created.",
  'market.listingCancelled': "Listing cancelled and custody returned.",
  'market.withdrawn': "Asset returned to your save.",
  'market.error.generic': "The market operation could not be completed.",
  'market.error.wallet_migration_required': "Your wallet is waiting for its initial IdleCoin migration.",
  'market.error.migration_amnesty_pending': "Wallet migration is waiting for the amnesty cap configuration.",
  'market.error.insufficient_market_balance': "Insufficient balance for this purchase.",
  'market.error.insufficient_listing_fee': "Insufficient balance to pay the listing fee.",
  'market.error.item_deposit_cap_reached': "This item's daily deposit limit has been reached.",
  'market.error.pokemon_deposit_cap_reached': "This rarity's daily deposit limit has been reached.",
  'market.error.pokemon_not_in_save': "This Pokémon is not in your synced save yet. Wait a few seconds and try again.",
  'market.error.item_not_in_save': "This quantity is not in your synced save yet. Wait a few seconds and try again.",
  'market.error.listing_not_buyable': "This listing is no longer available.",
  'market.error.bulk_quantity_unavailable': "There is not enough quantity within the selected price.",
  'market.error.delivery_not_claimable': "This delivery was already claimed or is unavailable.",
  'market.tab.requests': "Requests",
  'market.tab.offers': "Offers",
  'market.tab.history': "History",
  'market.tab.ignored': "Ignored",
  'market.ignoreSeller': "Ignore this seller",
  'market.pokemonOnlyOffer': "Pokémon offer",
  'market.offerFrom': "Received from {name}",
  'market.offerTo': "Sent to {name}",
  'market.offerSummary': "{qty}× · {pokemon} Pokémon included",
  'market.accept': "Accept",
  'market.reject': "Reject",
  'market.withdrawOffer': "Withdraw offer",
  'market.offersTitle': "Offers",
  'market.offersSubtitle': "Money and Pokémon remain in escrow until the response.",
  'market.received': "Received",
  'market.sent': "Sent",
  'market.noReceivedOffers': "No received offers.",
  'market.noSentOffers': "No sent offers.",
  'market.addPokemon': "Add Pokémon (optional)",
  'market.noPokemonForOffer': "No Pokémon available to offer.",
  'market.offerEscrowWarning': "The offered balance and Pokémon stay server-protected until accepted, rejected, or withdrawn.",
  'market.sendOffer': "Send offer",
  'market.offerSent': "Offer sent.",
  'market.offerAccepted': "Offer accepted and settled.",
  'market.offerRejected': "Offer rejected and escrow returned.",
  'market.offerWithdrawn': "Offer withdrawn and escrow returned.",
  'market.requestBy': "Requested by {name}",
  'market.requestQtyPrice': "{qty}× for {price} {currency}/ea",
  'market.anyPokemon': "No additional filters",
  'market.fulfill': "Fulfill",
  'market.myRequest': "My request",
  'market.escrowActive': "Balance in escrow",
  'market.requestsTitle': "Requests",
  'market.requestsSubtitle': "Funded buy orders that can be fulfilled from inventory.",
  'market.searchRequests': "Search requests...",
  'market.openRequests': "Open requests",
  'market.noRequests': "No open requests.",
  'market.myRequests': "My requests",
  'market.noMyRequests': "You have no active requests.",
  'market.createRequest': "Create request",
  'market.assetType': "Asset type",
  'market.itemSlug': "Item code",
  'market.species': "Species",
  'market.requestEscrowWarning': "The full value stays in escrow and is automatically returned on cancel or expiry.",
  'market.publishRequest': "Publish request",
  'market.fulfillRequest': "Fulfill request",
  'market.noEligibleAsset': "No eligible asset in your save or custody.",
  'market.fulfillFor': "Fulfill for {price} {currency}",
  'market.requestPublished': "Request published with funded escrow.",
  'market.requestFulfilled': "Request fulfilled. Payment received.",
  'market.requestCancelled': "Request cancelled and balance returned.",
  'market.historyTitle': "History",
  'market.historySubtitle': "Purchases, sales, and recent price references.",
  'market.role.buyer': "Purchase",
  'market.role.seller': "Sale",
  'market.noHistory': "No completed transactions.",
  'market.recentMedians': "30-day medians",
  'market.tradeCount': "{count} trade(s)",
  'market.noMedians': "Not enough data yet.",
  'market.ignoredTitle': "Ignored players",
  'market.ignoredSubtitle': "Listings and requests from these players are hidden.",
  'market.unignore': "Unignore",
  'market.noIgnored': "You are not ignoring anyone.",
  'market.ignored': "Player ignored.",
  'market.unignored': "Player removed from ignored list.",
  'market.error.emptyOffer': "Include IdleCoin, Emerald, or at least one Pokémon.",
  'market.error.insufficient_offer_balance': "Insufficient balance to fund this offer.",
  'market.error.insufficient_request_balance': "Insufficient balance to fund this request.",
  'market.error.listing_not_offerable': "This listing no longer accepts offers.",
  'market.error.offer_no_longer_settleable': "This offer can no longer be settled.",
  'market.error.request_not_fulfillable': "This request can no longer be fulfilled.",
  'market.searchAssets': "Search inventory and custody...",
  'market.searchPokemon': "Search Pokémon to offer...",
  'market.error.market_rate_limit_exceeded': "Too many operations in a row. Wait a moment and try again.",

  'tut.next': 'Next',
  'tut.skip': 'Skip tutorial',
  'tut.skipConfirm': 'Skip the tutorial? You can reopen it in Settings.',
  'tut.skipYes': 'Skip',
  'tut.skipNo': 'Keep going',
  'tut.restart': 'Replay tutorial',
  'tut.progress': '{current}/{total}',
  'tut.veteranToast': 'Tutorial is available in Settings → Replay tutorial.',
  'tut.welcome.title': 'Welcome to IdleMon',
  'tut.welcome.body': 'A quick tour of the main pieces. You can skip anytime.',
  'tut.cityWalk.title': 'Saffron City',
  'tut.cityWalk.body': 'This is the safe zone. Walk with W A S D and talk to NPCs when you need them.',
  'tut.teamHud.title': 'Your team',
  'tut.teamHud.body': 'Your active party lives here. The main partner leads automatic battles.',
  'tut.partnerBars.title': 'HP and XP',
  'tut.partnerBars.body': 'The green bar is health; the lower one is Pokémon experience.',
  'tut.currency.title': 'IdleCoin and Emerald',
  'tut.currency.body': 'IdleCoin comes from battles and sales. Emerald is the premium currency.',
  'tut.openAtlas.title': 'Hunt Atlas',
  'tut.openAtlas.body': 'Open the Atlas to choose where to hunt.',
  'tut.pickRoute.title': "Choose the type",
  'tut.pickRoute.body': "Start with the highlighted type. Each type has its own Pokémon list.",
  'tut.pickLevelOne.title': "Choose level 1",
  'tut.pickLevelOne.body': "Select Lv. 1: it is the safe band for learning how hunts work.",
  'tut.pickSpecies.title': "Choose the Pokémon",
  'tut.pickSpecies.body': "Now choose which level 1 Pokémon you want to search for.",
  'tut.startHunt.title': "Start the hunt",
  'tut.startHunt.body': "Everything is ready. Tap Hunt to travel to the selected route.",
  'tut.battleAuto.title': 'Automatic combat',
  'tut.battleAuto.body': 'The game hunts on its own. Watch the status and step in when you want.',
  'tut.enemyHud.title': 'Wild Pokémon',
  'tut.enemyHud.body': 'The opponent’s name, type, and HP show up here during the fight.',
  'tut.restButton.title': 'Rest',
  'tut.restButton.body': 'Use Rest to arm offline rewards when you leave the game.',
'tut.capturePanel.title': "Capture panel",
'tut.capturePanel.body': "When a wild faints, this panel appears. Pick a ball and try to catch it.",
'tut.captureBall.title': "Throw a ball",
'tut.captureBall.body': "Choose a ball above, then tap Throw to attempt the capture.",
'tut.navCaptures.title': "Capture history",
'tut.navCaptures.body': "Open the log of recent captures.",
'tut.navMyPokemon.title': "My Pokémon",
'tut.navMyPokemon.body': "Manage the party and inspect each member.",
'tut.teamDetail.title': "Team details",
'tut.teamDetail.body': "Check IVs, moves, and promote reserves here.",
'tut.navInventory.title': "Inventory",
'tut.navInventory.body': "Open the bag for balls, potions, and loot.",
'tut.potions.title': "Potions",
'tut.potions.body': "Use potions to restore your partner mid-hunt.",
'tut.navAutomation.title': "Automation",
'tut.navAutomation.body': "Tune auto-heal and auto-capture.",
'tut.autoPotion.title': "Auto-potion",
'tut.autoPotion.body': "Turn it on to heal automatically when HP drops.",
'tut.autoCaptureVip.title': "Auto-capture (VIP)",
'tut.autoCaptureVip.body': "Auto-catching after a KO is a VIP perk. Free players use balls from the panel.",
'tut.healNurse.title': "Nurse Joy",
'tut.healNurse.body': "In the city, Nurse Joy heals your team for free.",
'tut.shopNpc.title': "Sam's shop",
'tut.shopNpc.body': "Open the shop to buy supplies or sell loot.",
'tut.shopSell.title': "Sell drops",
'tut.shopSell.body': "The Sell tab turns loot into IdleCoin.",
'tut.deposit.title': "Deposit",
'tut.deposit.body': "Store items and move Pokémon between the party and the Box.",
'tut.depositBox.title': "Box",
'tut.depositBox.body': "Extra Pokémon stay in the Box until you need them.",
'tut.profile.title': "Trainer profile",
'tut.profile.body': "Track level, prestige, and progress.",
'tut.navSpecialization.title': "Specialization",
'tut.navSpecialization.body': "Spend talent points to shape your playstyle.",
'tut.specInvest.title': "Talent trees",
'tut.specInvest.body': "Each tree boosts a playstyle. You earn the first point at level 50.",
'tut.systemsDiscovery.title': "Systems",
'tut.systemsDiscovery.body': "Shortcuts to gyms, raids, crafting, and more.",
'tut.navPokedex.title': "Pokédex",
'tut.navPokedex.body': "Browse species, routes, and what you have registered.",
'tut.navSystems.title': "Systems hub",
'tut.navSystems.body': "Open the hub for upgrades and advanced modes.",
'tut.hubUpgrades.title': "Upgrades",
'tut.hubUpgrades.body': "Permanent boosts that speed up progression.",
'tut.navAltar.title': "Shiny altar",
'tut.navAltar.body': "Offer shiny cards at the altar for rare bonuses.",
'tut.navBreeding.title': "Breeding",
'tut.navBreeding.body': "Breed Pokémon for eggs with better IVs.",
'tut.dailyGift.title': "Daily gift",
'tut.dailyGift.body': "Check in every day to keep your reward streak.",
'tut.gamePass.title': "Game Pass",
'tut.gamePass.body': "Season pass with free and premium rewards. Informational only — no pressure to buy.",
'tut.market.title': "Market",
'tut.market.body': "Trade with other players.",
'tut.chat.title': "Chat",
'tut.chat.body': "Talk to the world, share tips, and show off captures.",
'tut.compareLab.title': "Compare lab",
'tut.compareLab.body': "Compare two Pokémon side by side.",
'tut.emeraldStore.title': "Emerald store",
'tut.emeraldStore.body': "Emerald buys cosmetics and boosts. Optional — the core loop works without it.",
  'common.new': 'New',
};
